(ns practitest.frontend.components.project-assistant.subs
  (:require
    [practitest.frontend.common.format-utils :as fu]
    [re-frame.core :as re-frame]))

;; TODO: re-frame 1.3.0+ adds :-> shorthand

(re-frame/reg-sub ::project-assistant (fn [db _] (:project-assistant db)))
(re-frame/reg-sub ::panel-open? :<- [::project-assistant] (fn [s _] (:panel-open? s)))
(re-frame/reg-sub ::active-tab :<- [::project-assistant] (fn [s _] (or (:active-tab s) :chat)))
(re-frame/reg-sub ::connected? :<- [::project-assistant] (fn [s _] (:connected? s)))
(re-frame/reg-sub ::streaming? :<- [::project-assistant] (fn [s _] (:streaming? s)))
(re-frame/reg-sub ::error :<- [::project-assistant] (fn [s _] (:error s)))
(re-frame/reg-sub ::retriable? :<- [::project-assistant] (fn [s _] (:retriable? s)))
(re-frame/reg-sub ::messages :<- [::project-assistant] (fn [s _] (:messages s)))
(re-frame/reg-sub ::rename-state :<- [::project-assistant] (fn [s _] (:rename-state s)))
(re-frame/reg-sub ::history-search :<- [::project-assistant] (fn [s _] (:history-search s "")))
(re-frame/reg-sub ::conversation-title :<- [::project-assistant] (fn [s _] (get-in s [:conversation :title])))
(re-frame/reg-sub ::budget-warning? :<- [::project-assistant] (fn [s _] (= "soft_limit" (get-in s [:budget :status]))))

(re-frame/reg-sub
  ::conversations
  :<- [::project-assistant]
  (fn [state _]
    (->> (:conversations state)
         (sort-by :last_message_at #(compare %2 %1)))))

(re-frame/reg-sub
  ::filtered-conversations
  :<- [::conversations]
  :<- [::history-search]
  (fn [[conversations query] _]
    (filter #(fu/substring-search? (:title %) query) conversations)))
